module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.12468/images/landing-page-creator.png"